export default function Callout({ title, children }) {
  return (
    <aside className="my-6 p-4 sm:p-5 bg-[#FBF3DA] border-l-4 border-[#B58200] border-t border-r border-b border-[#E4E1D8] rounded-[4px] text-[16px] text-[#1A1C1F]">
      {title && (
        <div className="font-bold text-[#2E3A46] text-[15px] uppercase tracking-wider mb-2 font-mono">
          {title}
        </div>
      )}
      <div className="space-y-2 leading-relaxed">
        {children}
      </div>
    </aside>
  );
}
